import { Button, Input, Item, ItemActions, ItemContent, ItemHeader, ItemTitle, Textarea } from '@ibsys/kit';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DESTRUCTIVE_BUTTON_CLASS } from '@/shared/lib';
import { AttributeFormValues } from '../validation';

type Props = {
  index: number;
  disabled?: boolean;
  onRemove: () => void;
  structureAttributes: NonNullable<NonNullable<AttributeFormValues['structure']>['attributes']>;
};

export const StructureGroupItem: FC<Props> = ({ index, disabled, onRemove, structureAttributes }) => {
  const { t } = useTranslation(['attributes', 'common']);
  const { control } = useFormContext<AttributeFormValues>();

  return (
    <Item variant="outline" size="sm" className="w-full">
      <ItemHeader>
        <ItemTitle>
          {t('attributes:referenceValue')} {index + 1}
        </ItemTitle>
        <ItemActions>
          {!disabled && (
            <Button
              variant="ghost"
              color="destructive"
              className={DESTRUCTIVE_BUTTON_CLASS}
              size="sm"
              onClick={onRemove}
            >
              {t('common:delete')}
            </Button>
          )}
        </ItemActions>
      </ItemHeader>
      <div className="flex flex-col gap-2">
        {structureAttributes.map((attr) => (
          <Item key={attr.code} variant={'outline'}>
            <ItemHeader>
              <ItemTitle>{attr.name}</ItemTitle>
            </ItemHeader>
            <ItemContent className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <Input
                control={control}
                name={`structure.groups.${index}.items.${attr.code}.code`}
                label={t('attributes:code')}
                disabled={disabled}
              />
              <Input
                control={control}
                name={`structure.groups.${index}.items.${attr.code}.value`}
                label={t('attributes:value')}
                required
                disabled={disabled}
              />
              <Textarea
                control={control}
                name={`structure.groups.${index}.items.${attr.code}.description`}
                label={t('attributes:description')}
                rows={2}
                disabled={disabled}
                className={'sm:col-span-2'}
              />
            </ItemContent>
          </Item>
        ))}
      </div>
    </Item>
  );
};
